<template>
  <span class="temporary-transfer-pill t3 -t_medium">
    <sword-icon-wuk name="hourglass" />
    {{ formatDate(startDate) }} - {{ formatDate(endDate) }}
  </span>
</template>

<script>

import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'TemporaryTransferPill',
  components: {
    SwordIconWuk
  },
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);

      return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      }).format(date);
    },
  },
};
</script>

<style lang="scss" scoped>
.temporary-transfer-pill {
  display: flex;
  flex: none;
  align-items: center;
  border-radius: 0.5rem;
  padding: 0.125rem 0.75rem 0.125rem 0.5rem;
  color: $secondary-color;
  background-color: rgba($secondary-color-rgb, 0.1);
}
</style>
